
define('text!plugins/radio/template.html',[],function () { return '<div class="row">\n    <div class="large-12 small-centered columns">\n        radio TEMPLATE has not been made.\n    </div>\n</div>\n';});

